export default function isValidLink(cta_link, cta_text) {
  return (cta_link && (cta_link.url || cta_link.uid)) &&
    cta_text[0] &&
    "text" in cta_text[0] &&
    cta_text[0].text !== ""
    ? true
    : false;
}
